module.exports = __webpack_public_path__ + "img/187w.07f68d1.jpg";